import { Card, CardHeader, Typography, Button, Stack } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdContactPhone } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import { setDialog } from "../../../../app/slices/contactPersonSlice";
import ContactPersonForm from "../../form";

const ContactPersonHeader = () => {
  const _ContactPerson = useSelector((state) => state.contactPerson);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            جهات الاتصال
          </Typography>
        }
        avatar={<MdContactPhone size={20} />}
        action={
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة
            </Button>
          </Stack>
        }
      />
      {_ContactPerson.contactPerson.dialog ? <ContactPersonForm /> : null}
    </Card>
  );
};

export default ContactPersonHeader;
